const useKeyPress = props => {
  const keyPressedMapper = {
    Enter: props.onEnter,
    ArrowLeft: props.onArrowLeft,
    ArrowRight: props.onArrowRight,
    Delete: props.onDelete,
    Backspace: props.onBackspace,
    Tab: props.onTab,
    Escape: props.onEscape,
    ArrowUp: props.onArrowUp,
    ArrowDown: props.onArrowDown,
    PageUp: props.onPageUp,
    PageDown: props.onPageDown,
    Home: props.onHome,
    End: props.onEnd,
    Espace: props.onEspace
  };
  const handleKeyPress = event => {
    var _props$onKeyPress;
    if ((event === null || event === void 0 ? void 0 : event.key) === ' ') {
      var _props$onEspace;
      (_props$onEspace = props.onEspace) === null || _props$onEspace === void 0 ? void 0 : _props$onEspace.call(props, event);
    } else {
      var _keyPressedMapper$eve;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (_keyPressedMapper$eve = keyPressedMapper[event === null || event === void 0 ? void 0 : event.key]) === null || _keyPressedMapper$eve === void 0 ? void 0 : _keyPressedMapper$eve.call(keyPressedMapper, event);
    }
    (_props$onKeyPress = props.onKeyPress) === null || _props$onKeyPress === void 0 ? void 0 : _props$onKeyPress.call(props, event);
  };
  return {
    handleKeyPress
  };
};

export { useKeyPress };
//# sourceMappingURL=useKeyPress.js.map
